module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	// bg1: 'https://www.loliapi.com/acg?t=' + Date.now(),
	// bg2: 'https://www.loliapi.com/acg?t=' + Date.now(),
	// bg3: 'https://www.loliapi.com/acg?t=' + Date.now(),
	bg1:'https://static.hqcode.cn/uploads/2025/06/a9de0911-f751-413d-b551-80c8bd193114.jpg',
	bg2:'https://static.hqcode.cn/uploads/2025/06/43f0ab62-2dcd-426e-a4eb-bb5a6936549f.jpg',
	bg3:'https://static.hqcode.cn/uploads/2025/06/7382aac5-7eb5-4d73-914c-2ecb912eeb2c.jpg',


	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: 'ALong\'s Blog'
}
